<script>
import {mapActions} from "vuex";
import {countries} from "../../../../../utils/countries";
import {regexPatterns} from "../../../../../utils/utils";
import AbnAcnInput from "../../../../../components/common/abnAcnInput.vue";
import PromoCodeInput from "../../../../common/promoCodeInput.vue";

export default {
  name: "uConnectMoreUserDetailsStep",
  components: {PromoCodeInput, AbnAcnInput },
  data() {
    return {
      moreDetailsForm: {
        firstName: "",
        lastName: "",
        abnAcn: "",
        agentRegistrationNumber: "",
        companyName: "",
        businessRegistrationNumber: "",
        outsideAustralia: false,
        countryCode: '+61',
        phoneNumber: "",
        promoCode: ""
      },
      promoCodeValid: false,
      selectProductCode: '',
      couponDetails: null
    };
  },
  computed: {
    isNextButtonDisabled() {
      // Disable button if a promo code is entered but is not yet validated
      if (this.moreDetailsForm.promoCode && this.moreDetailsForm.promoCode.length > 0) {
        return !this.promoCodeValid;
      }
      // Otherwise, the button should be enabled
      return false;
    },
    formRules () {
      const moreDetailsFromRules =  {
        firstName: {
          required: true,
          message: "Please enter First Name",
          trigger: "blur",
        },
        lastName: {
          required: true,
          message: "Please enter Last Name",
          trigger: "blur",
        },
        countryCode: {
          required: true,
          message: "Please select your country code",
          trigger: ["change", "blur"]
        },
        phoneNumber: {
          required: true,
          message: "Please enter valid mobile number",
          trigger: "blur",
          pattern: regexPatterns.mobileRegEx,
        },

      };
      if (!this.moreDetailsForm.outsideAustralia) {
        moreDetailsFromRules.abnAcn = [{
          required: true,
          message: "Please input your ABN/ACN",
          trigger: "blur",
          pattern: regexPatterns.abnAndAcn,
        }];
        if (this.isRLAMandatory()) {
          moreDetailsFromRules.agentRegistrationNumber = [{
            required: true,
            message: "Please input your RLA number",
            trigger: "blur",
          }];
        }
        moreDetailsFromRules.companyName = [{
          required: true,
          message: "Please input your Company name",
          trigger: "blur",
        }];
        // Clear any existing validation message for Business Registration Number
        this.$nextTick(() => {
          this.$refs.moreDetailsForm.clearValidate('businessRegistrationNumber');
        });
      }else {

        moreDetailsFromRules.companyName = [{
          required: true,
          message: "Please input your company name",
          trigger: "blur",
        }];
        moreDetailsFromRules.businessRegistrationNumber = [{
          required: true,
          message: "Please input your Business Registration Number",
          trigger: "blur",
        },];
        // Clear any existing validation message for ABN/ACN
        this.$nextTick(() => {
          this.$refs.moreDetailsForm.clearValidate('abnAcn');
        });
      }
      return moreDetailsFromRules;
    }
  },
  mounted() {
    this.moreDetailsForm.firstName = this.$store.state.uConnect.firstName;
    this.moreDetailsForm.lastName = this.$store.state.uConnect.lastName;
    this.moreDetailsForm.countryCode = this.$store.state.uConnect.countryCode ? this.$store.state.uConnect.countryCode : "+61";
    this.moreDetailsForm.abnAcn = this.$store.state.uConnect.abnAcn;
    this.moreDetailsForm.agentRegistrationNumber = this.$store.state.uConnect.agentRegistrationNumber;
    this.moreDetailsForm.companyName = this.$store.state.uConnect.companyName;
    this.moreDetailsForm.businessRegistrationNumber = this.$store.state.uConnect.businessRegistrationNumber;
    this.moreDetailsForm.phoneNumber = this.$store.state.uConnect.mobileNumber;

    this.selectProductCode = this.$store.state.uConnect.subscribedUConnectProductCode;
    this.couponDetails = this.$store.state.uConnect.couponDetails;
    console.log("couponDetails", this.couponDetails);
    // this.handleReleasePromoCode();
  },
  methods: {
    ...mapActions("uConnect", ["updateUConnectUserDetails", "releaseCouponCode"]),
    countries() {
      return countries
    },
    isRLAMandatory() {
      return this.selectProductCode === 'UCON_STND_ELITE'
        || this.selectProductCode === 'UCON_STND_ELITE_NEW';
    },
    handleCompanyNameFound(name) {
      this.moreDetailsForm.companyName = name;
      // Also validate the company name field now that it's populated
      this.$refs.moreDetailsForm.validateField('companyName');
    },
    validateField(field) {
      this.$refs.moreDetailsForm.validateField(field);
    },
    handleOutsideAustraliaChange(val) {
      console.log("handleOutsideAustraliaChange", val);
      if (val) {
        this.moreDetailsForm.abnAcn = ""; // Clear the field when not required
      }
      this.$refs.moreDetailsForm.clearValidate('abnAcn'); // Clear validation message
    },
    handlePromoCodeValidation(isValid) {
      this.promoCodeValid = isValid;
    },
    goToTermsAndConditionsStep(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          if (this.moreDetailsForm.promoCode && !this.promoCodeValid) {
            this.$message.error('Please validate your promo code before proceeding.');
            return;
          }
          var uConnectRegistrationKey = localStorage.getItem("uConnectRegistrationKey");
          const params = {
            userId: this.$store.state.uConnect.userId,
            email: this.$store.state.uConnect.email,
            firstName: this.moreDetailsForm.firstName,
            lastName: this.moreDetailsForm.lastName,
            abnAcn: this.moreDetailsForm.abnAcn,
            agentRegistrationNumber: this.moreDetailsForm.agentRegistrationNumber,
            companyName: this.moreDetailsForm.companyName,
            businessRegistrationNumber: this.moreDetailsForm.businessRegistrationNumber,
            countryCode: this.moreDetailsForm.countryCode,
            mobileNumber: this.moreDetailsForm.phoneNumber,
            isOutsideAustralia: this.moreDetailsForm.outsideAustralia,
            promoCode: this.moreDetailsForm.promoCode,
            uConnectRegistrationKey: uConnectRegistrationKey,
          }
          this.updateUConnectUserDetails({params, callback: this.updateUConnectUserDetailsCallback})


        }
      });
    },
    updateUConnectUserDetailsCallback(res) {
      console.log("res--moreDetails", res);
      if (res.data.code == 0) {
        localStorage.setItem("uConnectRegistrationKey", res.data.data.uConnectRegistrationKey);
        this.$store.commit("uConnect/updateUserFirstName", {
          firstName: this.moreDetailsForm.firstName
        })
        this.$store.commit("uConnect/updateUserLastName", {
          lastName: this.moreDetailsForm.lastName
        })
        this.$store.commit("uConnect/updateContactNumber", {
          contactNumber: {
            countryCode: this.moreDetailsForm.countryCode,
            phoneNumber: this.moreDetailsForm.phoneNumber,
          },
        });
        this.$store.commit("uConnect/updateAbnAcn", {
          abnAcn: this.moreDetailsForm.abnAcn,
        });
        this.$store.commit("uConnect/updateAgentRegistrationNumber", {
          agentRegistrationNumber: this.moreDetailsForm.agentRegistrationNumber
        });
        this.$store.commit("uConnect/updateCompanyName", {
          companyName: this.moreDetailsForm.companyName,
        });
        this.$store.commit("uConnect/updateBusinessRegistrationNumber", {
          businessRegistrationNumber: this.moreDetailsForm.businessRegistrationNumber,
        });
        this.$emit('stepChanged', 2);
        this.$router.push({name: 'uConnectTnCStep'});
      }else if (
        res.data.code == 90000 ||
        res.data.code == 90002 ||
        res.data.code == 90001) {
        this.$box.alert('', res.data.message ,'error');
        this.$router.push("/pricing");
      }
    },
    handleReleasePromoCode() {
      var uConnectRegistrationKey = localStorage.getItem("uConnectRegistrationKey");
      const params = {
        userId: this.$store.state.uConnect.userId,
        email: this.$store.state.uConnect.email,
        couponCode: this.moreDetailsForm.promoCode,
        uConnectRegistrationKey: uConnectRegistrationKey
      };
      this.releaseCouponCode({
        params,
        callback: this.handleReleasePromoCodeCallback
      });
    },
    handleReleasePromoCodeCallback(res) {
      if (res.data.code === 0) {
        this.$message.success("Promo code released successfully!");
      } else {
        this.$message.error(res.data.message || "Invalid promo code.");
      }
    },
  }
}
</script>

<template>
      <div class="setup-container">
        <el-row type="flex" justify="center">
          <el-col :xs="24" :sm="12" class="content">
            <p class="step-text">STEP 2 OF 3</p>
            <h2>Further Details</h2>
            <p class="description">Just a few more steps and you’re finished!</p>

            <el-form ref="moreDetailsForm" :model="moreDetailsForm" :rules="formRules">
              <el-form-item prop="firstName">
                <el-input v-model="moreDetailsForm.firstName" placeholder="First Name"></el-input>
              </el-form-item>
              <el-form-item prop="lastName">
                <el-input v-model="moreDetailsForm.lastName" placeholder="Last Name"></el-input>
              </el-form-item>
              <el-form-item prop="phoneNumber">
                <el-row :gutter="5">
                  <el-col :span="8">
                    <el-select
                      v-model="moreDetailsForm.countryCode"
                      placeholder="Country Code"
                      filterable
                    >
                      <el-option
                        v-for="country in countries()"
                        :key="country.code"
                        :label="`${country.code} ${country.dialCode}`"
                        :value="country.dialCode">
                        <span><b>{{ country.name }}</b> <span style="color: #9a9a9a">({{ country.code }})</span> {{ country.dialCode }}</span>
                      </el-option>
                    </el-select>
                  </el-col>
                  <el-col :span="16">
                    <el-input v-model="moreDetailsForm.phoneNumber" placeholder="Mobile Number"
                              @input="moreDetailsForm.phoneNumber = moreDetailsForm.phoneNumber.replace(/[^\d]/g, '')"
                    >
                      <template slot="append"><i class="el-icon-check"/></template>
                    </el-input>
                  </el-col>
                </el-row>
              </el-form-item>
              <el-form-item prop="abnAcn">
                <abn-acn-input
                  v-model="moreDetailsForm.abnAcn"
                  :disabled="moreDetailsForm.outsideAustralia"
                  @company-name-found="handleCompanyNameFound"
                />
              </el-form-item>
              <el-form-item prop="outsideAustralia" style="display: flex;">
                <el-checkbox class="outside-aus-checkbox"
                               v-model="moreDetailsForm.outsideAustralia"
                               @change="handleOutsideAustraliaChange">Outside Australia</el-checkbox>
              </el-form-item>
              <el-form-item prop="companyName">
                <el-input v-model="moreDetailsForm.companyName" placeholder="Company Name" :disabled="!moreDetailsForm.outsideAustralia"></el-input>
              </el-form-item>
              <el-form-item prop="businessRegistrationNumber" v-if="moreDetailsForm.outsideAustralia">
                <el-input v-model="moreDetailsForm.businessRegistrationNumber" placeholder="Business Registration Number"></el-input>
              </el-form-item>
              <el-form-item prop="agentRegistrationNumber"  v-if="!moreDetailsForm.outsideAustralia">
              <el-input v-model="moreDetailsForm.agentRegistrationNumber" :placeholder="`Agent Registration ${isRLAMandatory() ? '' : '(Optional)'}`"
                          @input="moreDetailsForm.agentRegistrationNumber = moreDetailsForm.agentRegistrationNumber.replace(/[^\d]/g, '')">
                  <template slot="prepend">RLA</template>
                </el-input>
              </el-form-item>
              <el-form-item prop="promoCode">
                <promo-code-input v-model="moreDetailsForm.promoCode" :couponDetails="couponDetails"  @validated="handlePromoCodeValidation"/>
              </el-form-item>
              <el-form-item>
                <el-button  type="primary" class="next-button" @click="goToTermsAndConditionsStep('moreDetailsForm')"  :disabled="isNextButtonDisabled">Next</el-button>
              </el-form-item>
            </el-form>
          </el-col>
        </el-row>
      </div>
</template>

<style scoped lang="css">
/* step2a */
.setup-container {
  padding: 20px;
  text-align: center;
}

.content {
  background: white;
  padding: 30px;
  border-radius: 10px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.icons {
  font-size: 40px;
  color: #333;
}

.step-text {
  font-size: 14px;
  font-weight: bold;
  color: #555;
  margin-top: 10px;
}

h2 {
  font-size: 22px;
  font-weight: bold;
  margin-top: 10px;
}

.description {
  font-size: 14px;
  color: #666;
  margin-top: 10px;
}

.next-button {
  margin-top: 20px;
  background: #003333;
  color: #ffffff;
  border: none;
  width: 100%;
  padding: 12px;
  font-size: 16px;
}
/* step2b */
.setup-container {
  padding: 20px;
  text-align: center;
}

.content {
  background: white;
  padding: 30px;
  border-radius: 10px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  width: 100%;
  max-width: 400px;
}

.step-text {
  font-size: 14px;
  font-weight: bold;
  color: #555;
  margin-bottom: 10px;
}

h2 {
  font-size: 22px;
  font-weight: bold;
  margin-bottom: 10px;
}

.description {
  font-size: 14px;
  color: #666;
  margin-bottom: 20px;
}

.el-input {
  width: 100%;
}
/* tnc */


.tnc-content {
  background: white;
  padding: 30px;
  border-radius: 10px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  width: 90%;

}

.pdf-container {
  width: 100%;
  height: 30%;
  object-fit: contain;
}
.outside-aus-checkbox {
  font-weight: 600;
  color: #003333;
  border-color: #003333;
}
.outside-aus-checkbox :hover {
  border-color: #003333 !important;
}
.outside-aus-checkbox /deep/ .el-checkbox__label {
  color: #003333;
}
.outside-aus-checkbox /deep/ .el-checkbox__input.is-indeterminate .el-checkbox__inner {
  background-color: #003333 !important;
  border-color: #003333 !important;
}
.outside-aus-checkbox /deep/ .el-checkbox__input.is-checked .el-checkbox__inner  {
  background-color: #003333 !important;
  border-color: #003333 !important;

}

.next-button.is-disabled {
  color: #FFF;
  background-color: rgba(0, 51, 51, 0.31);
  border-color: rgba(0, 51, 51, 0.31);
}
</style>



// WEBPACK FOOTER //
// src/components/register/uConnectRegistration/steps/userDetailsSteps/uConnectMoreUserDetailsStep.vue